/**
 * CustomerDashboardShell — Feb 2026 (Modern Card Theme · Phase 1)
 *
 * Thin theme-aware switcher that renders either the legacy neon-terminal
 * dashboard OR the new Modern card-based dashboard based on the current
 * user's `ui_theme` preference. This is the entry point registered in
 * `App.js` — the underlying legacy + modern dashboards remain completely
 * independent files so the two design languages don't cross-contaminate
 * during Phase 1.
 */
import { useTheme } from '../../context/ThemeContext';
import { CustomerDashboard as CustomerDashboardLegacy } from './CustomerDashboard';
import { CustomerDashboardModern } from './CustomerDashboardModern';

export function CustomerDashboardShell() {
  const { isModern } = useTheme();
  return isModern ? <CustomerDashboardModern /> : <CustomerDashboardLegacy />;
}

export default CustomerDashboardShell;
